import { Account } from '../../components/accountPage/Account';

export const AccountPage = () => {
  return (
    <div>
      <Account />
    </div>
  );
};
